export default __webpack_public_path__ + "f236440a512d96e130a82a350fd78bb1.svg";